import React, { useEffect, useRef, useMemo } from "react";
import { Box, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import EventCard from "./EventCard";
import { getMyEvents } from "../../../../Redux/Reducers/communityReducer";
import Noevent from "../../../../Assets/css/Community/NoEvents.webp";
import usePagination from "../Feeds/usePagination";
import EventCardSkeleton from "../../../LoadingSkeleton/EventCardSkeleton";

const MyEvents = () => {
  const exploreType = useSelector((state) => state?.community?.exploreType);
  const loaderRef = useRef();
  
  // Memoize fetchParams to prevent unnecessary recreations
  const fetchParams = useMemo(() => ({
    my_events: true,
    type: exploreType
  }), [exploreType]);
  
  const {
    data: events,
    loading: loadingEvents,
    hasMore,
    handleLoadMore,
    handleRefresh,
  } = usePagination(
    (state) => state?.community?.myEvents,
    getMyEvents,
    fetchParams  // Use memoized params
  );

  console.log("events", events)

  // Intersection Observer for infinite scroll
  useEffect(() => {
    const currentLoader = loaderRef.current;
    if (!currentLoader || !hasMore) return;
    
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !loadingEvents) {
          handleLoadMore();
        }
      },
      { rootMargin: "200px" }
    );
    
    observer.observe(currentLoader);
    return () => {
      if (currentLoader) {
        observer.unobserve(currentLoader);
      }
    };
  }, [hasMore, loadingEvents, handleLoadMore]);

  // Refresh when exploreType changes
  useEffect(() => {
    handleRefresh();
  }, [exploreType]); // Only run when exploreType changes

  const showNoEvents = !loadingEvents && events?.length === 0;

  return (
    <Box>
      {showNoEvents ? (
        <Box sx={{ 
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'center', 
          justifyContent: 'center', 
          height: '60vh', 
          textAlign: 'center', 
          color: '#555' 
        }}>
          <img
            src={Noevent}
            alt="No Events"
            style={{ width: "80px", marginBottom: "16px", opacity: 0.8 }}
          />
          <Typography variant="h6">No events found</Typography>
        </Box>
      ) : (
        <>
          {events?.map((event) => (
            <EventCard key={`${event.id}-${events.indexOf(event)}`} event={event} />
          ))}
          
          {/* Show skeleton only when loading more data (not initial load) */}
          {loadingEvents && events.length > 0 && <EventCardSkeleton />}
          
          {!hasMore && events?.length > 0 && (
            <Typography 
              align="center" 
              sx={{ 
                p: 3, 
                color: 'text.secondary',
                fontStyle: 'italic'
              }}
            >
              You've reached the end of events
            </Typography>
          )}
          
          <div ref={loaderRef} style={{ height: "1px", width: "100%" }} />
        </>
      )}
    </Box>
  );
};

export default MyEvents;